SirTrevor.Locales.en.blocks = $.extend(SirTrevor.Locales.en.blocks, {
  // Override the uploaded_items widget description
  uploaded_items: {
    title: "Uploaded Item Row",
    description: "This widget displays uploaded items in a horizontal row. Each item should be less than 10MB in size. Optionally, you can add a heading and/or text to be displayed adjacent to the items. The item caption and link URL fields are also optional.",
    caption: 'Caption',
    link: 'Link URL'
  },
});
